import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setReviewsReducer, addReviewReducer, removeReviewReducer, updateReviewReducer } from "../reducers/";

export const fetchReviewsForCoupon = createAsyncThunk(
    "reviews/fetchForCoupon",
    async (couponId) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/ratings/coupon/${couponId}`);
        const data = await res.json();
        const map = {};
        (data.ratings || []).forEach(r => { map[r.id] = r; });
        return map;
    }
);

const initialState = {
    reviews: {},
    status: "idle",
    error: null,
};

const reviewSlice = createSlice({
    name: "reviews",
    initialState,
    reducers: {
        setReviews: setReviewsReducer,
        addReview: addReviewReducer,
        removeReview: removeReviewReducer,
        updateReview: updateReviewReducer,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchReviewsForCoupon.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(fetchReviewsForCoupon.fulfilled, (state, action) => {
                Object.assign(state.reviews, action.payload);
                state.status = "succeeded";
            })
            .addCase(fetchReviewsForCoupon.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export const { setReviews, addReview, removeReview, updateReview } = reviewSlice.actions;
export default reviewSlice.reducer;
